var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 1,
    fill: "#4800BD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 22,
    height: 1,
    fill: "#4800BD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 22,
    height: 1,
    fill: "#4800BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenuIcon);
export default __webpack_public_path__ + "static/media/mobile-menu-icon.5061a20964bea6bf455b6d0890064c2a.svg";
export { ForwardRef as ReactComponent };